// extracted by mini-css-extract-plugin
export default {"workspace":"NewWorkspaceModal_workspace__EGMsk","upload":"NewWorkspaceModal_upload__JAzTh","uploadBtn":"NewWorkspaceModal_uploadBtn__eIU7D","btn":"NewWorkspaceModal_btn__bWkc-"};